import { Grid, Box } from "@mui/material";

const InvoiceFormLayout = ({ children, editMode, fileUrl, fileType, fileName }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
                {children}
            </Grid>

            <Grid item xs={12} md={4}>
                <Box sx={{ position: 'sticky', top: 0 }}>
                    <InvoiceFilePreview
                        editMode={editMode}
                        fileUrl={fileUrl}
                        fileType={fileType}
                        fileName={fileName}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

export default InvoiceFormLayout;


const getFileTypeFromUrl = (url) => {
    if (!url) return null;

    if (url.startsWith("data:")) {
        const match = url.match(/^data:(.*?);/);
        return match ? match[1] : null;
    }

    const extension = url.split('.').pop().toLowerCase();
    switch (extension) {
        case "pdf": return "application/pdf";
        case "jpg":
        case "jpeg": return "image/jpeg";
        case "png": return "image/png";
        default: return null;
    }
};

const InvoiceFilePreview = ({ editMode, fileUrl, fileType, fileName }) => {
    if (!editMode || !fileUrl) return null;

    const resolvedType = fileType || getFileTypeFromUrl(fileUrl);
    const resolvedName = fileName || "invoice";

    const isPdf = resolvedType === "application/pdf";

    return (
        <Box sx={{ mt: 0.5 }}>
            {isPdf ? (
                <Box sx={{ width: "100%", height: "calc(100vh - 200px)" }}>
                    <object
                        data={fileUrl}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style={{
                            display: "block",
                            border: "1px solid #ddd",
                            borderRadius: 4,
                            backgroundColor: "#f9f9f9",
                        }}
                    />
                </Box>

            ) : (
                <img
                    src={fileUrl}
                    alt={resolvedName}
                    style={{ width: "100%", borderRadius: 4 }}
                />
            )}
        </Box>
    );
};
